import { executeGraphqlRequest } from 'apollo/graphql-request';

export interface StorageUsage {
  usedBytes: number;
  // Null when the plan sets no limit.
  limitBytes: number | null;
}

const STORAGE_USAGE_QUERY = `
  query StorageUsage {
    storageUsage {
      usedBytes
      limitBytes
    }
  }
`;

// Storage used and Storage limit of the signed-in Account.
export async function fetchStorageUsage(accessToken?: string): Promise<StorageUsage> {
  const response = await executeGraphqlRequest<{ storageUsage: StorageUsage }>(
    STORAGE_USAGE_QUERY,
    {},
    { accessToken, requestName: 'StorageUsage' }
  );

  return response.storageUsage;
}
